import PageLoader from '../components/PageLoader';
import { CREDITOR_MATCH_REVIEW_ROLES } from '../constants/roles';
import { useCurrentUser } from '../hooks/useCurrentUser';

/**
 * Route guard for intake's own queues (#1434).
 *
 * Mirrors `require_role("admin", "intake_supervisor", "intake")` on the API, so
 * the screen and the endpoints behind it agree about who may open it. Kept in
 * its own module rather than beside the guards in `App.tsx` so the role list is
 * testable without loading the entire application.
 */
export default function IntakeQueueRoute({ children }: { children: React.ReactNode }) {
  const { data: currentUser, isLoading } = useCurrentUser();
  if (isLoading) return <PageLoader />;
  if (currentUser && !CREDITOR_MATCH_REVIEW_ROLES.includes(currentUser.role)) {
    return (
      <div style={{ padding: '3rem', textAlign: 'center' }}>
        <h2 style={{ color: 'var(--text-muted)', fontWeight: 600, fontSize: '1.1rem' }}>Access Denied</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>This queue is worked by intake. Ask an administrator if you need access.</p>
      </div>
    );
  }
  return <>{children}</>;
}
